export const colors = {
  background: '#0B0F14',
  surface: '#151B24',
  surfaceElevated: '#1A2230',
  glass: 'rgba(21, 27, 36, 0.72)',
  glassBorder: 'rgba(255, 255, 255, 0.08)',
  text: '#F4F7FB',
  textMuted: '#8B98A8',
  accent: '#3DD6A4',
  accentMuted: '#2A9B78',
  danger: '#F87171',
  warning: '#F59E0B',
  border: '#243041',
  /** iOS-style tab bar glass */
  tabBarGlass: 'rgba(22, 28, 38, 0.62)',
  tabBarGlassBorder: 'rgba(255, 255, 255, 0.14)',
  tabBarHairline: 'rgba(255, 255, 255, 0.09)',
  tabBarInactive: 'rgba(139, 152, 168, 0.85)',
} as const;

export const radii = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 999,
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
} as const;

export const typography = {
  display: {
    fontSize: 36,
    fontWeight: '700' as const,
    lineHeight: 42,
  },
  title: {
    fontSize: 28,
    fontWeight: '700' as const,
    lineHeight: 34,
  },
  headline: {
    fontSize: 20,
    fontWeight: '600' as const,
    lineHeight: 26,
  },
  body: {
    fontSize: 16,
    fontWeight: '400' as const,
    lineHeight: 22,
  },
  caption: {
    fontSize: 13,
    fontWeight: '400' as const,
    lineHeight: 18,
  },
  label: {
    fontSize: 11,
    fontWeight: '600' as const,
    lineHeight: 14,
    letterSpacing: 0.6,
  },
} as const;
